module.exports = __webpack_public_path__ + "static/img/thermometre-mobile.af16e72.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/thermometre-mobile.png
// module id = 1H57
// module chunks = 1